<template>
  <layout-default-appbar filterable :filters="filters">
    Coleta Peças
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { COLETA_QUERIES } from '@/constants/QUERY_FILTERS';

export default {
  name: 'ViewAtendimentoAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {

      filters: [
        COLETA_QUERIES.createdFrom,
        COLETA_QUERIES.createdBefore,
      ],
    };
  },
};
</script>
